import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    marginTop: 100,
  },
}))

export default useStyles
